import AltInstance from '../../../../Common/Globals/Scripts/AltInstance';
import RatesSearchApi from '../Apis/RatesSearchApi';
import ActionHelper from '../../../../Common/Actions/ActionHelper';
import NotificationActions from '../../../../Common/Actions/NotificationActions';
import { saveResponseAsAsync, getTimestampForFileName } from '../../../../Common/Utilities/FileUtilities.js';
import { mapUiSelectionToApiFormat } from '../Business/RatesSearch';

class RatesSearchActions {
    constructor() {
        this.generateActions('selectionChangedInUi', 'rateCardsDeleted', 'searchCriteriaLookupsLoaded', 'searchCriteriaChanged', 'resetSearchCriteria', 'viewableRatesLoaded', 'ownerSelectionChanged', 'commandAuthorisationsLoaded');
    }

    async exportRates(searchCriteria, options) {
        NotificationActions.clearNotifications();

        const response = await ActionHelper.executeRequest(() => RatesSearchApi.exportRates(
            ...(mapUiSelectionToApiFormat(searchCriteria, options))
        ));
        const fileName = 'Rates ' + getTimestampForFileName() + '.csv';
        await saveResponseAsAsync(response, fileName);
    }

    async loadSearchCriteriaLookups() {
        const response = await ActionHelper.executeRequest(() => RatesSearchApi.loadSearchCriteriaLookups());
        this.searchCriteriaLookupsLoaded(response);
    }

    async loadViewableRateCards(searchCriteria, options) {
        NotificationActions.clearNotifications();

        const response = await ActionHelper.executeRequest(() => RatesSearchApi.loadViewableRateCards(
            ...(mapUiSelectionToApiFormat(searchCriteria, options))
        ));

        const notifyResultsReceived = () => this.viewableRatesLoaded(response);
        if(response.length === 0) {
            notifyResultsReceived();
        }
        else {
            const commandsThatMayBeExecuted = {
                deleteRateCards: [response.map(rc => rc.rateCardId)]
            }

            //make request for authorisations while rendering is in progress to avoid lag
            const authorisationsTask = ActionHelper.executeRequest(() => RatesSearchApi.loadRateCardAuthorisations(commandsThatMayBeExecuted));

            notifyResultsReceived();

            const authorisations = await authorisationsTask;
            this.commandAuthorisationsLoaded(authorisations);
        }
    }

    async deleteRateCards(rateCardIds) {
        NotificationActions.notificationReceived({
            title: 'Deleting....',
            icon: 'notched circle loading',
            messages: ['The rate cards are being deleted.'],
            closeable: false
        });

        await ActionHelper.executeRequest(() => RatesSearchApi.deleteRateCards(rateCardIds));
        this.rateCardsDeleted(rateCardIds);
        NotificationActions.notificationReceived({
            icon: 'check',
            severity: 'success',
            title: `Rate card${ rateCardIds.length === 1 ? '' : 's' } deleted`,
            messages: [`The selected rate ${ rateCardIds.length === 1 ? 'card has' : 'cards have' } been deleted.`]
        });
    }
}

export default AltInstance.createActions(RatesSearchActions);
